export default __webpack_public_path__ + "static/media/img.982d8c4f.png";